/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The platform-managed inference function
 */
export const InferenceSpendCapKeyType = {
  Chat: "chat",
  Internal: "internal",
} as const;
/**
 * The platform-managed inference function
 */
export type InferenceSpendCapKeyType = ClosedEnum<
  typeof InferenceSpendCapKeyType
>;

export type InferenceSpendCap = {
  /**
   * Monthly usage in USD
   */
  creditsUsed: number;
  /**
   * Whether the platform-managed key is disabled
   */
  disabled: boolean;
  /**
   * The platform-managed inference function
   */
  keyType: InferenceSpendCapKeyType;
  /**
   * The enforced monthly spend cap in USD
   */
  monthlyCredits: number;
};

/** @internal */
export const InferenceSpendCapKeyType$inboundSchema: z.ZodMiniEnum<
  typeof InferenceSpendCapKeyType
> = z.enum(InferenceSpendCapKeyType);

/** @internal */
export const InferenceSpendCap$inboundSchema: z.ZodMiniType<
  InferenceSpendCap,
  unknown
> = z.pipe(
  z.object({
    credits_used: z.number(),
    disabled: z.boolean(),
    key_type: InferenceSpendCapKeyType$inboundSchema,
    monthly_credits: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "credits_used": "creditsUsed",
      "key_type": "keyType",
      "monthly_credits": "monthlyCredits",
    });
  }),
);

export function inferenceSpendCapFromJSON(
  jsonString: string,
): SafeParseResult<InferenceSpendCap, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => InferenceSpendCap$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'InferenceSpendCap' from JSON`,
  );
}
